import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ProtectedRoute } from '../components/auth/index.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business DB辞書レイアウト。DB辞書関連ページのOutletラッパー
 * @graph-connects none
 */
export const Route = createFileRoute('/db-dictionary')({
  component: DbDictionaryLayout,
});

/**
 * DB Dictionary レイアウトラッパー
 * @graph-connects ProtectedRoute [calls] 内部メンバー限定でアクセスをガードする
 */
function DbDictionaryLayout() {
  return (
    <ProtectedRoute pageKey="dbDictionary">
      <Outlet />
    </ProtectedRoute>
  );
}
